/*
 * Copyright (c) 2026 Talent Catalog.
 *
 * This program is free software: you can redistribute it and/or modify it under
 * the terms of the GNU General Public License as published by the Free
 * Software Foundation, either version 3 of the License, or any later version.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or
 * FITNESS FOR A PARTICULAR PURPOSE. See the GNU General Public License
 * for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program. If not, see https://www.gnu.org/licenses/.
 */

import {Component, OnInit} from '@angular/core';
import {Partner} from "../../../../model/partner";
import {AuthenticationService} from "../../../../services/authentication.service";

@Component({
  selector: 'app-final-agreement',
  templateUrl: './final-agreement.component.html',
  styleUrls: ['./final-agreement.component.scss']
})
export class FinalAgreementComponent implements OnInit {

  constructor(private authService: AuthenticationService) { }
   loggedInUserPartner: Partner;

  ngOnInit(): void {
    this.loggedInUserPartner = this.authService.getLoggedInUser()?.partner;
  }

}
